import { U3141_DOCUMENT_UPLOAD_MAX_FILES } from '../U3141Service';

/** Taille max fichier document (50 Mo) — aligné dialogue ajout. */
export const U3141_DOCUMENT_UPLOAD_MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;

export type U3141DocumentUploadValidationErrorKey = 'msgDocumentFileTooLarge' | 'msgDocumentUploadInvalidPdf';

export interface U3141AppendDocumentUploadFilesResult {
  files: File[];
  rejectedOverMax: boolean;
  duplicateNames: string[];
  rejectedNonPdf: string[];
}

function isPdfFile(file: File): boolean {
  const name = file.name.toLowerCase();
  return name.endsWith('.pdf') || file.type === 'application/pdf';
}

/** Ajoute des PDF à la file (dédoublonnage par nom, plafond global). */
export function u3141AppendDocumentUploadFilesToQueue(
  current: File[],
  incoming: File[],
): U3141AppendDocumentUploadFilesResult {
  const duplicateNames: string[] = [];
  const rejectedNonPdf: string[] = [];
  const pdfIncoming = incoming.filter((file) => {
    if (!isPdfFile(file)) {
      rejectedNonPdf.push(file.name);
      return false;
    }
    return true;
  });

  if (pdfIncoming.length === 0 && incoming.length > 0) {
    return { files: current, rejectedOverMax: false, duplicateNames, rejectedNonPdf };
  }

  const seen = new Set(current.map((f) => f.name.toLowerCase()));
  const merged = [...current];
  for (const file of pdfIncoming) {
    const key = file.name.toLowerCase();
    if (seen.has(key)) {
      duplicateNames.push(file.name);
      continue;
    }
    if (merged.length >= U3141_DOCUMENT_UPLOAD_MAX_FILES) {
      return { files: current, rejectedOverMax: true, duplicateNames, rejectedNonPdf };
    }
    seen.add(key);
    merged.push(file);
  }

  merged.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
  return { files: merged, rejectedOverMax: false, duplicateNames, rejectedNonPdf };
}

export function u3141ValidateDocumentUploadFile(file: File): U3141DocumentUploadValidationErrorKey | null {
  if (!isPdfFile(file)) {
    return 'msgDocumentUploadInvalidPdf';
  }
  if (file.size > U3141_DOCUMENT_UPLOAD_MAX_FILE_SIZE_BYTES) {
    return 'msgDocumentFileTooLarge';
  }
  return null;
}
